import { SECURITY_TRAILS_HISTORICAL_EDGE_LABEL } from './investigationEdgeLabels';

export const HISTORICAL_DNS_RECORD_TYPES = ['A', 'AAAA', 'MX', 'NS', 'SOA', 'TXT'];

export function filterHistoricalDnsByType(records, recordType) {
  if (!records?.length) return [];
  const type = String(recordType || 'A').toUpperCase();
  return records.filter((row) => String(row.recordType || '').toUpperCase() === type);
}

export function historicalDnsFirstColumnHeader(recordType) {
  switch (String(recordType || 'A').toUpperCase()) {
    case 'A':
    case 'AAAA':
      return 'IP Addresses';
    case 'MX':
      return 'MX Record';
    case 'NS':
      return 'Nameserver';
    case 'SOA':
      return 'SOA Record';
    case 'TXT':
      return 'TXT Record';
    default:
      return 'Record';
  }
}

export function historicalDnsDisplayValue(row) {
  if (!row) return 'N/A';
  const type = String(row.recordType || '').toUpperCase();
  if (type === 'MX' && row.mxPriority != null && row.recordValue) {
    return `${row.mxPriority} · ${row.recordValue}`;
  }
  return row.recordValue || 'N/A';
}

/** Target string for investigate / add-to-map actions on a historical DNS row. */
export function historicalDnsInvestigateTarget(row) {
  if (!row) return null;
  const type = String(row.recordType || '').toUpperCase();
  const raw = row.recordValue;
  if (raw == null) return null;
  const value = String(raw).trim();
  if (!value || value === 'N/A') return null;
  if (type === 'SOA') {
    const primary = value.split('·')[0].trim();
    return primary || value;
  }
  return value;
}

/** deriveFrom + connectionLabel for historical DNS row actions (relationship map shows "(Historical)"). */
export function historicalDnsInvestigateMeta(row) {
  const type = String(row?.recordType || '').toUpperCase();
  switch (type) {
    case 'A':
    case 'AAAA':
      return {
        deriveFrom: 'IP_ADDRESS',
        connectionLabel: SECURITY_TRAILS_HISTORICAL_EDGE_LABEL.IP_ADDRESS,
      };
    case 'MX':
      return {
        deriveFrom: 'MX_RECORD',
        connectionLabel: SECURITY_TRAILS_HISTORICAL_EDGE_LABEL.MX_RECORD,
      };
    case 'NS':
    case 'SOA':
      return {
        deriveFrom: 'DOMAIN_ON_NS',
        connectionLabel: SECURITY_TRAILS_HISTORICAL_EDGE_LABEL.DOMAIN_ON_NS,
      };
    default:
      return { deriveFrom: null, connectionLabel: null };
  }
}

export function countHistoricalDnsByType(records) {
  const counts = Object.fromEntries(HISTORICAL_DNS_RECORD_TYPES.map((t) => [t, 0]));
  (records || []).forEach((row) => {
    const type = String(row.recordType || '').toUpperCase();
    if (counts[type] != null) counts[type] += 1;
  });
  return counts;
}
